import BaseBlock from "./BaseBlock";
import Swiper, {Autoplay, Navigation} from "swiper";

class TextWithMedia extends BaseBlock {

	init() {
		const sliderEl = this.block.querySelector(".swiper");
		if (sliderEl) {
			new Swiper(sliderEl, {
				loop: true,
				spaceBetween: 20,
				navigation: {
					prevEl: this.block.querySelector(".slider-btn-prev"),
					nextEl: this.block.querySelector(".slider-btn-next"),
				},
				autoplay: {
					delay: 5000,
					disableOnInteraction: false,
					pauseOnMouseEnter: true
				},
				modules: [Autoplay, Navigation]
			});
		}

	}
}

export default TextWithMedia;
